"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroupField = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const FormFields_1 = require("../FormFields");
const defaultStyles = (theme) => ({
    root: {
        paddingVertical: theme.spacing.unit,
    },
    titleWrapper: {
        paddingHorizontal: theme.spacing.unit * 2,
        paddingVertical: theme.spacing.unit,
    },
    label: {
        color: theme.palette.text.secondary,
    },
    helperText: Object.assign(Object.assign({}, theme.typography.caption), { color: theme.palette.text.secondary, paddingTop: theme.spacing.unit / 2 }),
    itemWrapper: {
        borderColor: theme.palette.divider,
        borderRadius: theme.shape.borderRadius,
        borderWidth: 1,
        marginHorizontal: theme.spacing.unit * 2
    },
});
/**
 * A component that renders form actions, i.e. submit or reset buttons
 * @param props
 */
const FormGroupField = (props) => {
    const { style, label, helperText } = props;
    const styles = core_1.useStyles('FormGroupField', props, defaultStyles);
    return (react_1.default.createElement(components_1.View, { style: [styles.root, style] },
        react_1.default.createElement(components_1.View, { style: styles.titleWrapper },
            react_1.default.createElement(components_1.Subtitle1, { style: styles.label }, label),
            helperText ? react_1.default.createElement(components_1.Body2, { style: styles.helperText }, helperText) : null),
        react_1.default.createElement(components_1.View, { style: styles.itemWrapper },
            react_1.default.createElement(FormFields_1.FormFields, Object.assign({}, props)))));
};
exports.FormGroupField = FormGroupField;
exports.FormGroupField.displayName = 'FormGroupField';
exports.FormGroupField.defaultProps = {};
